import { render, staticRenderFns } from "./contact-permissions.vue?vue&type=template&id=b130122e&scoped=true"
import script from "./contact-permissions.vue?vue&type=script&lang=js"
export * from "./contact-permissions.vue?vue&type=script&lang=js"
import style0 from "./contact-permissions.vue?vue&type=style&index=0&id=b130122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b130122e",
  null
  
)

export default component.exports